import { COUPLE } from "@/data/wedding";
import { GoldDivider } from "./Ornaments";

export const Footer = () => (
  <footer className="relative bg-[var(--kasavu)]">
    <div className="kasavu-border" />
    <div className="px-6 py-20 text-center">
      <p className="font-body text-[11px] uppercase tracking-mega text-[var(--gold-deep)]">
        With love &amp; blessings
      </p>
      <h2 className="mt-6 font-script text-6xl text-[var(--maroon)] md:text-8xl">
        {COUPLE.bride.name} &amp; {COUPLE.groom.name}
      </h2>
      <GoldDivider className="my-8" />
      <p className="mx-auto max-w-md font-display text-lg italic text-[var(--muted)]">
        {COUPLE.bride.parents}
      </p>
      <p className="mx-auto max-w-md font-display text-lg italic text-[var(--muted)]">
        {COUPLE.groom.parents}
      </p>
      <p className="mt-10 font-body text-xs tracking-[0.2em] text-[var(--muted)]">
        {COUPLE.savingDate} · Kerala, India
      </p>
    </div>
  </footer>
);
